import { defineQuery } from 'bitecs';
import { Wetness, Position, Tile } from '../world.js';

const TILE_SIZE = 16;
const playerQuery = defineQuery([Wetness, Position]);
const tileQuery = defineQuery([Tile]);

export function wetnessSystem(world) {
    const players = playerQuery(world);
    
    for (const player of players) {
        const currentWetness = Wetness.value[player];
        const tile = getTileAtPosition(world, Position.x[player], Position.y[player]);
        
        if (tile !== null) {
            if (Tile.type[tile] === 0) { // Water tile
                // Increase wetness when in water
                Wetness.value[player] = Math.min(100, currentWetness + Wetness.wettingRate[player]);
            } else { // Land tile
                // Decrease wetness when on land
                Wetness.value[player] = Math.max(0, currentWetness - Wetness.dryingRate[player]);
            }
        }
    }
    
    return world;
}

function getTileAtPosition(world, x, y) {
    const tiles = tileQuery(world);
    const tileX = Math.floor(x / TILE_SIZE);
    const tileY = Math.floor(y / TILE_SIZE);
    
    for (const tile of tiles) {
        if (Tile.x[tile] === tileX && Tile.y[tile] === tileY) {
            return tile;
        }
    }
    return null;
} 